// Thin client for the Express API. Every call carries the session cookie and
// turns a failed response into a thrown ApiError whose `code` matches the
// server's error strings, so callers can map straight onto translation keys.

export class ApiError extends Error {
  constructor(code, status) {
    super(code);
    this.code = code;
    this.status = status;
  }
}

const request = async (path, { method = 'GET', body } = {}) => {
  let response;
  try {
    response = await fetch(path, {
      method,
      credentials: 'include',
      headers: body === undefined ? undefined : { 'Content-Type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    // Network failure, offline, server down.
    throw new ApiError('network', 0);
  }

  if (response.status === 204) return null;

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    throw new ApiError((payload && payload.error) || 'server-error', response.status);
  }
  return payload;
};

export const fetchSession = () => request('/api/auth/me');
export const signInWithGoogle = (credential) => request('/api/auth/google', { method: 'POST', body: { credential } });
export const signOut = () => request('/api/auth/logout', { method: 'POST' });

export const fetchThreads = () => request('/api/messages/threads');
export const createThread = (subject, body) => request('/api/messages/threads', { method: 'POST', body: { subject, body } });
export const fetchThread = (id) => request(`/api/messages/threads/${id}`);
export const postMessage = (id, body) => request(`/api/messages/threads/${id}/messages`, { method: 'POST', body: { body } });

export const fetchAdminThreads = (unreadOnly) => request(`/api/admin/threads${unreadOnly ? '?unread=1' : ''}`);
export const fetchAdminStats = () => request('/api/admin/stats');
